export const LIST_BMAT_DETECTIONS_ITEM_FIELDS = `
    audio_deleted
    audio_id
    channel
    confidence
    country
    detection_id
    duration
    episode
    episode_number
    filename
    match_reference
    program_production_company
    show
    song_id
    timestamp
`;
